// Initializes the PostHog browser client (side-effect import).
import "@rallly/posthog/client";
